import { render } from "./app.vue?vue&type=template&id=4d21f74f&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=4d21f74f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d21f74f"

export default script